module.exports = __webpack_public_path__ + "static/media/trainingSteps_mobile.89e719f9.jpg";